import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AlertsPanel = ({ alerts, onRefresh }) => {
  const getAlertIcon = (type) => {
    const icons = {
      error: 'XCircle',
      warning: 'AlertTriangle',
      info: 'Info',
      success: 'CheckCircle'
    };
    return icons?.[type] || 'Info';
  };

  const getAlertColor = (type) => {
    const colors = {
      error: 'var(--color-destructive)',
      warning: 'var(--color-warning)',
      info: 'var(--color-primary)',
      success: 'var(--color-success)'
    };
    return colors?.[type] || 'var(--color-primary)';
  };

  const getAlertBgClass = (type) => {
    const classes = {
      error: 'bg-destructive/10 border-destructive',
      warning: 'bg-warning/10 border-warning',
      info: 'bg-primary/10 border-primary',
      success: 'bg-success/10 border-success'
    };
    return classes?.[type] || 'bg-primary/10 border-primary';
  };

  const getPriorityBadge = (priority) => {
    const badges = {
      critical: { label: 'Critical', class: 'bg-destructive text-destructive-foreground' },
      high: { label: 'High', class: 'bg-warning text-warning-foreground' },
      medium: { label: 'Medium', class: 'bg-primary/20 text-primary' },
      low: { label: 'Low', class: 'bg-muted text-muted-foreground' }
    };
    return badges?.[priority] || badges?.medium;
  };

  return (
    <div className="bg-card rounded-xl shadow-md p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-heading font-bold text-foreground flex items-center gap-2">
          <Icon name="Bell" size={24} color="var(--color-primary)" />
          Alerts & Notifications
        </h2>
        <Button onClick={onRefresh} variant="ghost" size="sm">
          <Icon name="RefreshCw" size={18} />
        </Button>
      </div>

      <div className="space-y-3">
        {alerts?.map((alert) => {
          const priorityBadge = getPriorityBadge(alert?.priority);
          return (
            <div
              key={alert?.id}
              className={`border rounded-lg p-4 ${getAlertBgClass(alert?.type)} transition-smooth hover:shadow-md`}
            >
              <div className="flex items-start gap-3">
                <Icon
                  name={getAlertIcon(alert?.type)}
                  size={24}
                  color={getAlertColor(alert?.type)}
                  className="flex-shrink-0 mt-0.5"
                />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="font-semibold text-foreground">{alert?.title}</h3>
                    <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${priorityBadge?.class}`}>
                      {priorityBadge?.label}
                    </span>
                  </div>
                  <p className="text-sm text-muted-foreground mb-3">{alert?.message}</p>
                  {alert?.action && (
                    <Button variant="outline" size="sm">
                      {alert?.action}
                    </Button>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AlertsPanel;